/**
 * Il valore arrivato come stringa (API, URL, JSON libero) è una chiave della
 * mappa? Solo le chiavi proprie: `in` e l'accesso con un cast troverebbero
 * anche `toString` o `constructor` del prototipo.
 */
export function isMapKey(map, value) {
    return (typeof value === 'string' &&
        Object.prototype.hasOwnProperty.call(map, value));
}
/** La voce della mappa per quel valore, o `undefined` se non ne è una chiave. */
export function findMapValue(map, value) {
    return isMapKey(map, value) ? map[value] : undefined;
}
//# sourceMappingURL=record-lookup.js.map